"use strict";
function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function (value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;
//# sourceMappingURL=_setToArray.js.map